<mat-checkbox class="mat-option" color="primary" [disableRipple]="true" [indeterminate]="isIndeterminate()"
    [checked]="isChecked()" (click)="$event.stopPropagation()" (change)="toggleSelection($event)">
    {{text}}
</mat-checkbox>